export default __webpack_public_path__ + "static/media/we-said-no-horny.9ddc393f.jpeg";